import { Link } from 'react-router-dom'
import {
  RiSparklingLine, RiHeartFill, RiTimeLine,
  RiArrowRightLine, RiBriefcaseLine, RiMapPinLine,
} from 'react-icons/ri'
import SEO from '../../components/seo/SEO'
import { breadcrumb } from '../../components/seo/jsonLd'

const PERKS = [
  { icon: RiSparklingLine, title: 'World-class training', desc: 'Quarterly workshops with international educators and brand partners.' },
  { icon: RiHeartFill,     title: 'People-first culture', desc: 'A team that celebrates wins, has each other\'s back and grows together.' },
  { icon: RiTimeLine,      title: 'Healthy work-life',    desc: 'Predictable rosters, paid leave, and breaks that respect your craft.' },
  { icon: RiBriefcaseLine, title: 'Above-market pay',     desc: 'Competitive base + tips + performance bonus + product commissions.' },
]

const ROLES = [
  { title: 'Senior Hair Stylist',     type: 'Full-time', loc: 'Anna Nagar, Chennai', summary: 'Lead cuts, colour and styling for our highest-spend guests.' },
  { title: 'Bridal Makeup Artist',    type: 'Full-time', loc: 'Anna Nagar, Chennai', summary: 'Own the bridal season — trials, on-location, and editorial shoots.' },
  { title: 'Skin Therapist (CIDESCO)', type: 'Full-time', loc: 'Anna Nagar, Chennai', summary: 'Deliver advanced facials, peels and skin consultations.' },
  { title: 'Nail Technician',         type: 'Part-time', loc: 'Anna Nagar, Chennai', summary: 'Mani-pedis, gel, extensions and nail art for a loyal clientele.' },
  { title: 'Front Desk & Concierge',  type: 'Full-time', loc: 'Anna Nagar, Chennai', summary: 'Be the first smile — own the guest experience end-to-end.' },
  { title: 'Apprentice / Trainee',    type: 'Internship', loc: 'Anna Nagar, Chennai', summary: 'Paid 6-month apprenticeship with a placement guarantee on completion.' },
]

export default function Careers() {
  return (
    <>
      <SEO
        title="Careers at Salon Vora — Beauty Jobs in Chennai"
        description="Join Salon Vora's team. We hire senior stylists, makeup artists, skin therapists, nail technicians and front-of-house staff. Above-market pay and great culture."
        path="/careers"
        jsonLd={breadcrumb([{ name: 'Home', url: '/' }, { name: 'Careers', url: '/careers' }])}
      />

      <div className="min-h-screen bg-salon-cream">
        <section className="relative bg-hero-gradient py-32 overflow-hidden">
          <div className="absolute inset-0 opacity-20"
            style={{ backgroundImage: 'radial-gradient(circle at 70% 30%, #C9963A 0%, transparent 60%)' }} />
          <div className="container-salon relative z-10 text-center max-w-3xl">
            <span className="section-tag mb-4 inline-block !text-salon-secondary !bg-salon-secondary/15">Careers</span>
            <h1 className="font-display text-4xl md:text-6xl text-white font-bold mb-4">
              Build a <span className="text-salon-secondary italic">Beautiful Career</span> with Us
            </h1>
            <p className="text-white/80 font-body text-lg">
              We hire passionate people who love their craft as much as their guests. If that's you, we want to meet you.
            </p>
          </div>
        </section>

        {/* Perks */}
        <section className="py-20 container-salon">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {PERKS.map((p) => (
              <div key={p.title} className="card p-6">
                <div className="w-12 h-12 rounded-2xl bg-salon-primary/10 flex items-center justify-center mb-4">
                  <p.icon className="text-salon-primary text-2xl" />
                </div>
                <p className="font-display font-semibold text-salon-dark text-lg mb-1">{p.title}</p>
                <p className="text-salon-muted font-body text-sm">{p.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Open roles */}
        <section className="py-16 bg-white">
          <div className="container-salon">
            <div className="text-center mb-12">
              <span className="section-tag">Open Roles</span>
              <h2 className="section-title mt-2">We're Currently Hiring</h2>
            </div>

            <div className="grid lg:grid-cols-2 gap-4 max-w-5xl mx-auto">
              {ROLES.map((r) => (
                <div key={r.title} className="rounded-2xl border border-salon-cream-dark hover:border-salon-primary/40
                                              transition-all duration-300 p-6 bg-white hover:shadow-salon-sm">
                  <div className="flex items-start justify-between gap-3 mb-3">
                    <p className="font-display font-semibold text-salon-dark text-lg">{r.title}</p>
                    <span className="badge badge-gold">{r.type}</span>
                  </div>
                  <p className="text-salon-muted font-body text-sm mb-4">{r.summary}</p>
                  <div className="flex items-center justify-between">
                    <span className="flex items-center gap-1 text-salon-muted font-body text-xs">
                      <RiMapPinLine /> {r.loc}
                    </span>
                    <a
                      href={`mailto:careers@salonvora.com?subject=Application: ${encodeURIComponent(r.title)}`}
                      className="inline-flex items-center gap-1 text-sm font-semibold text-salon-primary
                                 hover:gap-2 transition-all">
                      Apply <RiArrowRightLine />
                    </a>
                  </div>
                </div>
              ))}
            </div>

            <p className="text-center text-salon-muted font-body mt-10">
              Don't see your role? Email us anyway at <a href="mailto:careers@salonvora.com" className="text-salon-primary font-semibold hover:underline">careers@salonvora.com</a>.
            </p>
          </div>
        </section>

        {/* CTA */}
        <section className="py-20 bg-salon-cream">
          <div className="container-salon">
            <div className="bg-salon-primary rounded-3xl px-8 py-12 text-center">
              <h2 className="font-display text-white text-3xl md:text-4xl font-bold mb-3">Ready to join Salon Vora?</h2>
              <p className="text-white/80 font-body mb-8">Send your portfolio, CV and a short note about yourself.</p>
              <Link to="/contact" className="btn-gold text-base px-10 py-4">Get in Touch</Link>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
